var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageUrls)?_c('el-image',{staticStyle:{"width":"20px","height":"20px"},attrs:{"preview-src-list":_vm._f("imageUrls")(_vm.imageUrls),"src":require('@/static/img/icon_image.png')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }